import { FrontendOrganizationInvite } from '@trucksmarter/shared';

export const getInvalidSnackbarSubheaderText = (
  invite?: FrontendOrganizationInvite,
) =>
  `Please contact ${
    invite?.email || 'the admin'
  } if you need another invite to join the team.`;

export const getAcceptSnackbarSubheaderText = (
  invite?: FrontendOrganizationInvite,
) =>
  `You accepted the invite to join ${
    invite?.inviter.carrierName || 'the team'
  }.`;

export const getDeclineSnackbarSubheaderText = (
  invite?: FrontendOrganizationInvite,
) =>
  `If this was done in error, please reach out to ${
    invite?.email || 'the admin'
  } to resend the invite.`;
